import axios, { AxiosResponse } from "axios";
import { CompanyCreateRequest, CompanyEditForm, CompanyEditRequest, CompanyNameRequest } from "./CompanyForm";
import { ApplicationApi } from "../../../Routing";

/**
 * テナント情報管理 API
 */
export class CompanyService {

  // テナントの名前一覧取得API
  findCompanyNameList = async (
    param: CompanyNameRequest
  ): Promise<AxiosResponse> => {
    try {
      const res: AxiosResponse = await axios.post(
        ApplicationApi.companyName.apiUrl(),
        param
      );
      return res;
    } catch (err) {
      throw err;
    }
  };

  // 企業情報新規作成確認API
  createConfirm = async (param: CompanyEditForm): Promise<AxiosResponse> => {
    try {
      let request = new CompanyCreateRequest();
      request.createdata = param;

      const res: AxiosResponse = await axios.post(
        ApplicationApi.companyCreateConfirm.apiUrl(),
        request
      );
      return res;
    } catch (err) {
      throw err;
    }
  };

  // 企業情報新規作成API
  create = async (param: CompanyEditForm): Promise<AxiosResponse> => {
    try {
      let request = new CompanyCreateRequest();
      request.createdata = param;

      const res: AxiosResponse = await axios.post(
        ApplicationApi.companyCreateExecute.apiUrl(),
        request
      );
      return res;
    } catch (err) {
      throw err;
    }
  };

  // 企業情報編集取得API
  findByEditId = async (companyId: string): Promise<AxiosResponse> => {
    try {
      const res: AxiosResponse = await axios.get(
        ApplicationApi.companyDetail.apiUrl(companyId)
      );
      return res;
    } catch (err) {
      throw err;
    }
  };

  // 企業情報編集確認API
  updateConfirm = async (param: CompanyEditForm): Promise<AxiosResponse> => {
    try {
      let request = new CompanyEditRequest();
      request.editdata = param;

      const res: AxiosResponse = await axios.post(
        ApplicationApi.companyEditConfirm.apiUrl(),
        request
      );
      return res;
    } catch (err) {
      throw err;
    }
  };

  // 企業情報編集API
  update = async (param: CompanyEditForm): Promise<AxiosResponse> => {
    try {
      let request = new CompanyEditRequest();
      request.editdata = param;

      const res: AxiosResponse = await axios.post(
        ApplicationApi.companyEditExecute.apiUrl(),
        request
      );
      return res;
    } catch (err) {
      throw err;
    }
  };

  // 企業情報削除API
  delete = async (companyId: string): Promise<AxiosResponse> => {
    try {
      const res: AxiosResponse = await axios.post(ApplicationApi.companyDeleteExecute.apiUrl(), {
        companyId,
      });
      return res;
    } catch (err) {
      throw err;
    }
  };
}